import { UploadFileType } from "@quickpoint.me/shared";



export function generateFileUrl(type: UploadFileType, id: string) {
    if (type === "image") return `https://imagedelivery.net/KVUPIyykyRSaaOckEeUn5g/${id}/public`;
    if (type === "data" || type === "audio") return `https://datafiles.quickpoint.me/${id}`;
    throw Error("no file type defined");
}


